// extracted by mini-css-extract-plugin
export default {"content":"SB","wrapper":"TB","gif":"UB","textContent":"VB","gifContainer":"WB","proteinGif":"XB","counter_img":"YB","usage-container":"ZB","usage-list":"aC","checklist":"bC","counter_title":"cC","counter_wrapper":"eC","active":"fC","usage-counter":"gC","line":"hC"};
    if(module.hot) {
      // 1713996747415
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  